module.exports = __webpack_public_path__ + "img/hero_jp.51589b4.jpg";